module.exports = __webpack_public_path__ + "img/HOLA.a7f33da9.png";